(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["barrier-brand-card"] && !Shopify.designMode) return;
  try {
    
  class BarrierBrandCard extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('.barrier-brand-card__tab')];
      this.contents = [...this.querySelectorAll('[data-tab-content]')];
      this.tabs.forEach((btn) => {
        btn.addEventListener('click', () => this.activate(btn.dataset.tab));
      });
    }
    activate(index) {
      this.tabs.forEach((b) => b.classList.toggle('is-active', b.dataset.tab === index));
      this.contents.forEach((el) => el.classList.toggle('is-active', el.dataset.tabContent === index));
    }
  }
  customElements.define('barrier-brand-card', BarrierBrandCard);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barrier-showcase"] && !Shopify.designMode) return;
  try {
    
  class BarrierShowcase extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.barrier-showcase__slide')];
      this.viewport = this.querySelector('.barrier-showcase__images-viewport');
      this.track = this.querySelector('.barrier-showcase__images-track');
      this.realCount = this.slides.length;
      this.currentIndex = 0;
      this.isAnimating = false;
      this.cloneOffset = 0;

      // Suppress transitions during initial layout so items don't fade in from opacity 0
      this.style.setProperty('--transition-dur', '0s');

      this._setupTrackClones();
      this._refreshItems();
      this._positionTrack(false);
      this._updateItemPositions();

      // Restore transitions after first paint
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.style.removeProperty('--transition-dur');
        });
      });

      this.querySelectorAll('.barrier-showcase__arrow').forEach(btn => {
        btn.addEventListener('click', () => this.next());
      });

      if (this.track) {
        this.track.addEventListener('click', (e) => {
          const item = e.target.closest('.barrier-showcase__sachet');
          if (!item || !this.track.contains(item)) return;
          const pos = parseInt(item.dataset.pos, 10);
          if (pos === -1) this.prev();
          else if (pos === 1) this.next();
        });
        this.track.addEventListener('transitionend', (e) => {
          if (e.target !== this.track || e.propertyName !== 'transform') return;
          this._onTrackTransitionEnd();
        });
      }

      this._initSwipe();

      window.addEventListener('resize', () => this._positionTrack(false));

      // Reposition once layout settles — the section's CSS is loaded async
      // (media="print" onload trick), so on mobile the viewport's offsetWidth
      // may already equal the unstyled div width (~100vw) and never trigger a
      // change. Also observe a sachet, whose width jumps when --sachet-w
      // finally applies; that's the reliable signal that CSS has arrived.
      if (typeof ResizeObserver !== 'undefined') {
        let lastVw = 0;
        let lastIw = 0;
        this._resizeObserver = new ResizeObserver(() => {
          const vw = this.viewport ? this.viewport.offsetWidth : 0;
          const iw = this.allItems[0] ? this.allItems[0].offsetWidth : 0;
          if (!vw || !iw) return;
          if (vw === lastVw && iw === lastIw) return;
          lastVw = vw;
          lastIw = iw;
          this._positionTrack(false);
        });
        if (this.viewport) this._resizeObserver.observe(this.viewport);
        if (this.allItems[0]) this._resizeObserver.observe(this.allItems[0]);
      }
    }

    _setupTrackClones() {
      if (!this.track || this.realCount < 2) return;

      const real = [...this.track.querySelectorAll('.barrier-showcase__sachet')];
      const cloneCount = Math.min(2, this.realCount);

      // Trailing clones: copies of the first cloneCount real items
      for (let i = 0; i < cloneCount; i++) {
        const clone = real[i].cloneNode(true);
        clone.setAttribute('data-clone', 'true');
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('tabindex', '-1');
        clone.removeAttribute('data-real-index');
        this.track.appendChild(clone);
      }

      // Leading clones: copies of the last cloneCount real items, prepended in reverse
      for (let i = 0; i < cloneCount; i++) {
        const sourceIdx = this.realCount - 1 - i;
        const clone = real[sourceIdx].cloneNode(true);
        clone.setAttribute('data-clone', 'true');
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('tabindex', '-1');
        clone.removeAttribute('data-real-index');
        this.track.insertBefore(clone, this.track.firstChild);
      }

      this.cloneOffset = cloneCount;
    }

    _refreshItems() {
      this.allItems = this.track ? [...this.track.querySelectorAll('.barrier-showcase__sachet')] : [];
    }

    next() {
      if (this.isAnimating || this.realCount < 2) return;
      this._advance(this.currentIndex + 1);
    }

    prev() {
      if (this.isAnimating || this.realCount < 2) return;
      this._advance(this.currentIndex - 1);
    }

    _advance(newIndex) {
      this.isAnimating = true;

      const wrapped = ((newIndex % this.realCount) + this.realCount) % this.realCount;

      this.slides[this.currentIndex].classList.remove('barrier-showcase__slide--active');
      this.slides[wrapped].classList.add('barrier-showcase__slide--active');

      this.currentIndex = newIndex; // may temporarily be out of [0, realCount) — snap-back fixes this
      this._updateItemPositions();
      this._positionTrack(true);

      // If the destination is already visually correct (e.g. no track), end immediately
      if (!this.track || this.realCount < 2) {
        this.currentIndex = wrapped;
        this.isAnimating = false;
      }
    }

    _onTrackTransitionEnd() {
      this.isAnimating = false;

      if (this.realCount < 2) return;

      // If we landed on a clone position, snap back to the equivalent real
      // index without animation. Suppress all transitions on the host (track +
      // every item's opacity/scale) so changing data-pos doesn't cause the
      // items to re-animate after the jump.
      if (this.currentIndex < 0 || this.currentIndex >= this.realCount) {
        this.currentIndex = ((this.currentIndex % this.realCount) + this.realCount) % this.realCount;
        this.style.setProperty('--transition-dur', '0s');
        this._positionTrack(false);
        this._updateItemPositions();
        // Force reflow, then restore on next frame so future advances animate.
        this.offsetWidth;
        requestAnimationFrame(() => {
          this.style.removeProperty('--transition-dur');
        });
      }
    }

    _positionTrack(animated) {
      if (!this.track || !this.viewport || !this.allItems.length) return;

      const itemW = this.allItems[0].offsetWidth;
      if (!itemW) {
        // Element not laid out yet — retry on next frame
        requestAnimationFrame(() => this._positionTrack(animated));
        return;
      }
      const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 0;
      const slot = itemW + gap;
      const trackIdx = this.cloneOffset + this.currentIndex;
      const itemCenter = trackIdx * slot + itemW / 2;
      const translate = this.viewport.offsetWidth / 2 - itemCenter;

      if (animated) {
        this.track.style.transform = `translateX(${translate}px)`;
      } else {
        const prev = this.track.style.transition;
        this.track.style.transition = 'none';
        this.track.style.transform = `translateX(${translate}px)`;
        // Force reflow so the transition reset takes effect, then restore
        this.track.offsetWidth;
        this.track.style.transition = prev;
      }
    }

    _updateItemPositions() {
      if (!this.allItems.length) return;
      const trackIdx = this.cloneOffset + this.currentIndex;
      this.allItems.forEach((item, idx) => {
        item.dataset.pos = idx - trackIdx;
      });
    }

    _initSwipe() {
      const swipeArea = this.querySelector('.barrier-showcase__layout');
      if (!swipeArea) return;

      let startX = null;
      let startY = null;
      let pId = null;
      const THRESHOLD = 40;

      swipeArea.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        startX = e.clientX;
        startY = e.clientY;
        pId = e.pointerId;
      });

      swipeArea.addEventListener('pointerup', (e) => {
        if (pId === null || e.pointerId !== pId) return;
        const dx = e.clientX - startX;
        const dy = e.clientY - startY;
        startX = startY = pId = null;
        if (Math.abs(dy) > Math.abs(dx)) return;
        if (Math.abs(dx) < THRESHOLD) return;
        if (dx < 0) this.next();
        else this.prev();
      });

      swipeArea.addEventListener('pointercancel', () => {
        startX = startY = pId = null;
      });
    }
  }

  customElements.define('barrier-showcase', BarrierShowcase);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barrier-ugc"] && !Shopify.designMode) return;
  try {
    
  class BarrierUgc extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.barrier-ugc__track');
      this.slides = [...this.querySelectorAll('.barrier-ugc__slide')];
      this.ytPlayers = {};
      this.currentIndex = -1;
      this.playingIndex = -1;
      // Global sound state for the section: once the user turns sound on,
      // it carries over to the next auto-played video.
      this.soundOn = false;

      this._setupPlayButtons();
      this._setupMuteButtons();
      this._setupMediaClick();
      this._setupDragScroll();
      this._setupNavArrows();

      // Speed fix: lazy init — load players only when the section nears the viewport
      const start = () => {
        if (this._started) return;
        this._started = true;
        const hasYt = this.slides.some(s => s.dataset.videoType === 'youtube');
        if (hasYt) {
          this._initYouTubeApi();
        } else {
          this._setupLocalVideoListeners();
          this._autoPlayFirst();
        }
      };

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          if (entries.some(e => e.isIntersecting)) {
            io.disconnect();
            start();
          }
        }, { rootMargin: '300px' });
        io.observe(this);
      } else {
        start();
      }
    }

    /* ── YouTube IFrame API bootstrap ── */
    _initYouTubeApi() {
      window._barrierUgcInstances = window._barrierUgcInstances || [];
      window._barrierUgcInstances.push(this);

      if (window.YT && window.YT.Player) {
        this._createYtPlayers();
        return;
      }

      if (!document.querySelector('script[src*="youtube.com/iframe_api"]')) {
        const s = document.createElement('script');
        s.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(s);
      }

      const prev = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function() {
        if (typeof prev === 'function') prev();
        (window._barrierUgcInstances || []).forEach(inst => inst._createYtPlayers());
        window._barrierUgcInstances = [];
      };
    }

    _createYtPlayers() {
      this.slides.forEach((slide, i) => {
        if (slide.dataset.videoType !== 'youtube') return;
        const el = slide.querySelector('.barrier-ugc__yt');
        if (!el) return;

        this.ytPlayers[i] = new YT.Player(el, {
          videoId: el.dataset.videoId,
          playerVars: {
            mute: 1,
            controls: 0,
            playsinline: 1,
            rel: 0,
            modestbranding: 1
          },
          events: {
            onReady: (e) => { if (i === 0) this.playSlide(0); },
            onStateChange: (e) => {
              if (e.data === YT.PlayerState.ENDED) this._onEnded(i);
              if (e.data === YT.PlayerState.PLAYING) this._setPlaying(i);
              if (e.data === YT.PlayerState.PAUSED) this._setPaused(i);
            }
          }
        });
      });

      this._setupLocalVideoListeners();
    }

    _setupLocalVideoListeners() {
      this.slides.forEach((slide, i) => {
        if (slide.dataset.videoType !== 'local') return;
        const v = slide.querySelector('video');
        if (!v) return;
        v.addEventListener('ended', () => this._onEnded(i));
        v.addEventListener('play', () => this._setPlaying(i));
        v.addEventListener('pause', () => this._setPaused(i));
      });
    }

    _autoPlayFirst() {
      if (this.slides.length > 0) this.playSlide(0);
    }

    /* ── Sound state ── */

    _applySound(index) {
      const slide = this.slides[index];
      if (!slide) return;
      slide.classList.toggle('barrier-ugc__slide--unmuted', this.soundOn);
      const type = slide.dataset.videoType;
      if (type === 'local') {
        const v = slide.querySelector('video');
        if (v) {
          v.muted = !this.soundOn;
          if (this.soundOn) v.volume = 1;
        }
      } else if (type === 'youtube' && this.ytPlayers[index]) {
        try {
          if (this.soundOn) {
            this.ytPlayers[index].unMute();
            this.ytPlayers[index].setVolume(100);
          } else {
            this.ytPlayers[index].mute();
          }
        } catch(e) {}
      }
    }

    /* ── Play / Pause / Stop ── */

    stopAll() {
      this.slides.forEach((slide, i) => {
        slide.classList.remove('barrier-ugc__slide--playing');
        const type = slide.dataset.videoType;
        if (type === 'youtube' && this.ytPlayers[i]) {
          try { this.ytPlayers[i].pauseVideo(); } catch(e) {}
        } else if (type === 'local') {
          const v = slide.querySelector('video');
          if (v && !v.paused) v.pause();
        }
      });
      this.playingIndex = -1;
    }

    playSlide(index) {
      const slide = this.slides[index];
      if (!slide) return;

      this.stopAll();

      this.track.scrollTo({ left: slide.offsetLeft - this._centerOffset(slide), behavior: 'smooth' });

      // Carry the user's sound choice over BEFORE starting playback,
      // so an auto-advanced video keeps playing with sound on.
      this._applySound(index);

      const type = slide.dataset.videoType;
      if (type === 'youtube' && this.ytPlayers[index]) {
        this.ytPlayers[index].playVideo();
      } else if (type === 'local') {
        const v = slide.querySelector('video');
        if (v) {
          v.play().catch(() => {
            // Autoplay with sound blocked by the browser: fall back to muted.
            v.muted = true;
            slide.classList.remove('barrier-ugc__slide--unmuted');
            v.play().catch(() => {});
          });
        }
      }

      slide.classList.add('barrier-ugc__slide--playing');
      this.playingIndex = index;
      this.currentIndex = index;
    }

    pauseSlide(index) {
      const slide = this.slides[index];
      if (!slide) return;

      const type = slide.dataset.videoType;
      if (type === 'youtube' && this.ytPlayers[index]) {
        try { this.ytPlayers[index].pauseVideo(); } catch(e) {}
      } else if (type === 'local') {
        const v = slide.querySelector('video');
        if (v && !v.paused) v.pause();
      }

      slide.classList.remove('barrier-ugc__slide--playing');
      this.playingIndex = -1;
    }

    _setPlaying(index) {
      this.slides[index]?.classList.add('barrier-ugc__slide--playing');
      this.playingIndex = index;
    }

    _setPaused(index) {
      this.slides[index]?.classList.remove('barrier-ugc__slide--playing');
      if (this.playingIndex === index) this.playingIndex = -1;
    }

    _onEnded(index) {
      this.slides[index]?.classList.remove('barrier-ugc__slide--playing');
      const next = (index + 1) % this.slides.length;
      this.playSlide(next);
    }

    /* ── Center offset for mobile centering ── */
    _centerOffset(slide) {
      return (this.track.clientWidth - slide.offsetWidth) / 2;
    }

    /* ── Play button: toggle play/pause ── */
    _setupPlayButtons() {
      this.slides.forEach((slide, i) => {
        const btn = slide.querySelector('.barrier-ugc__play-btn');
        if (!btn) return;
        btn.addEventListener('click', () => {
          if (this.playingIndex === i) {
            this.pauseSlide(i);
          } else {
            this.playSlide(i);
          }
        });
      });
    }

    /* ── Mute button: square at the top-left of each video ── */
    _setupMuteButtons() {
      this.slides.forEach((slide, i) => {
        const btn = slide.querySelector('.barrier-ugc__mute-btn');
        if (!btn) return;
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const unmuted = slide.classList.toggle('barrier-ugc__slide--unmuted');
          this.soundOn = unmuted;
          const type = slide.dataset.videoType;
          if (type === 'local') {
            const v = slide.querySelector('video');
            if (v) {
              v.muted = !unmuted;
              if (unmuted) v.volume = 1;
            }
          } else if (type === 'youtube' && this.ytPlayers[i]) {
            try {
              if (unmuted) {
                this.ytPlayers[i].unMute();
                this.ytPlayers[i].setVolume(100);
              } else {
                this.ytPlayers[i].mute();
              }
            } catch(e2) {}
          }
        });
      });
    }

    /* ── Click on the video toggles play/pause ── */
    _setupMediaClick() {
      this.slides.forEach((slide, i) => {
        const media = slide.querySelector('.barrier-ugc__media');
        if (!media) return;
        media.addEventListener('click', (e) => {
          if (e.target.closest('.barrier-ugc__mute-btn')) return;
          if (this.playingIndex === i) {
            this.pauseSlide(i);
          } else {
            this.playSlide(i);
          }
        });
      });
    }

    /* ── Side arrows: move exactly one video per click ── */
    _setupNavArrows() {
      const leftBtn = this.querySelector('.barrier-ugc__nav--prev');
      const rightBtn = this.querySelector('.barrier-ugc__nav--next');
      if (!leftBtn || !rightBtn) return;
      // dir is the PHYSICAL direction of the arrow (right = +1, left = -1).
      // In an RTL track the slide order runs right-to-left, so moving
      // physically right means going to a LOWER index.
      const go = (dir) => {
        const len = this.slides.length;
        if (!len) return;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const delta = rtl ? -dir : dir;
        const base = this.currentIndex >= 0 ? this.currentIndex : 0;
        const target = (base + delta + len) % len;
        this.playSlide(target);
      };
      leftBtn.addEventListener('click', () => go(-1));
      rightBtn.addEventListener('click', () => go(1));
    }

    /* ── Desktop drag-to-scroll ── */
    _setupDragScroll() {
      const track = this.track;
      let isDown = false, startX = 0, scrollStart = 0, moved = false;

      track.addEventListener('mousedown', (e) => {
        isDown = true;
        moved = false;
        startX = e.pageX;
        scrollStart = track.scrollLeft;
        track.classList.add('barrier-ugc__track--grabbing');
      });

      track.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const dx = e.pageX - startX;
        if (Math.abs(dx) > 5) moved = true;
        track.scrollLeft = scrollStart - dx;
      });

      const stop = () => {
        if (!isDown) return;
        isDown = false;
        track.classList.remove('barrier-ugc__track--grabbing');
      };

      track.addEventListener('mouseup', stop);
      track.addEventListener('mouseleave', stop);
    }
  }

  customElements.define('barrier-ugc', BarrierUgc);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
